var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleMailComposer',{attrs:{"card-title":_vm.$t('resetPassword'),"card-text":_vm.$t('resetPasswordMailInfo'),"init-mail-subject":_vm.$t('groupAlert') + ' - ' + _vm.$t('resetPassword'),"to-email":_vm.toEmail,"to-name":_vm.toName,"sender-name":_vm.senderName,"init-email-text":_vm.mailBody},on:{"done":_vm.emitDone}})
}
var staticRenderFns = []

export { render, staticRenderFns }